export enum MetricType {
  TeamOverview = 'TeamOverview',
  MatchTeamPrevious = 'MatchTeamPrevious',
  MatchTeamOverview = 'MatchTeamOverview',
  Goalkeeper = 'Goalkeeper',
  Defender = 'Defender',
  Midfielder = 'Midfielder',
  Forward = 'Forward'
}

export enum MetricFinderKey {
  Team = 'team',
  Player = 'player',
  Match = 'match'
}
